import React from "react";
import Content from "../Content";
import { BaseDropdownMenuItem } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function DropdownMenuItem(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    shortcut = _ref.shortcut,
    icon = _ref.icon,
    disabled = _ref.disabled,
    indentContent = _ref.indentContent;
  return /*#__PURE__*/_jsx(BaseDropdownMenuItem, {
    onClick: onClick,
    disabled: disabled,
    indentContent: indentContent,
    children: /*#__PURE__*/_jsx(Content, {
      icon: icon,
      label: label,
      shortcut: shortcut
    })
  });
}
export default DropdownMenuItem;